import React from 'react';
import { TIMEFRAME } from './types';
import { Timeframe } from './timeframe/Timeframe';
import { useTranslation } from 'react-i18next';

interface IProps {
  updateRangeValue: (rangeValue: string) => void;
  currentRangeValue: string;
}

export const StaticCustomReport = ({
  currentRangeValue,
  updateRangeValue,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <Timeframe
      currentRangeValue={currentRangeValue}
      updateRangeValue={updateRangeValue}
      timeframeOptions={[
        { label: t('Day'), value: TIMEFRAME.DAY },
        { label: t('Week'), value: TIMEFRAME.WEEK },
        { label: t('Month'), value: TIMEFRAME.MONTH },
        { label: t('Year'), value: TIMEFRAME.YEAR },
        { label: t('Custom'), value: TIMEFRAME.CUSTOM },
      ]}
    />
  );
};
